import { render, staticRenderFns } from "./MayaErrorPageView.vue?vue&type=template&id=808831f6&"
import script from "./MayaErrorPageView.vue?vue&type=script&lang=js&"
export * from "./MayaErrorPageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports